import is from './index';

export const isArray = is.array;
export const isArrayOf = is.arrayOf;
export const isAsyncGeneratorFunction = is.asyncGeneratorFunction;
export const isAsyncFunction = is.asyncFunction;
export const isBigInt = is.bigint;
export const isBoolean = is.boolean;
export const isDate = is.date;
export const isDefined = is.defined;
export const isDomElement = is.domElement;
export const isEmpty = is.empty;
export const isError = is.error;
export const isFunction = is.function;
export const isGenerator = is.generator;
export const isGeneratorFunction = is.generatorFunction;
export const isInstanceOf = is.instanceOf;
export const isIterable = is.iterable;
export const isMap = is.map;
export const isNan = is.nan;
export const isNull = is.null;
export const isNullOrUndefined = is.nullOrUndefined;
export const isNumber = is.number;
export const isNumericString = is.numericString;
export const isObject = is.object;
export const isOneOf = is.oneOf;
export const isPlainFunction = is.plainFunction;
export const isPlainObject = is.plainObject;
export const isPrimitive = is.primitive;
export const isPromise = is.promise;
export const isPropertyOf = is.propertyOf;
export const isRegexp = is.regexp;
export const isSet = is.set;
export const isString = is.string;
export const isSymbol = is.symbol;
export const isUndefined = is.undefined;
export const isWeakMap = is.weakMap;
export const isWeakSet = is.weakSet;
